import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core'
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms'
import { toNumber } from 'lodash-es'

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngModel][min][type="number"]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: MinDirective, multi: true },
  ],
})
export class MinDirective implements Validator, OnChanges {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('min') min: number | string

  onChange = () => {}

  ngOnChanges(changes: SimpleChanges): void {
    this.onChange()
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return Validators.min(toNumber(this.min))(control)
  }
}
